var _linearGradient, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgElement = function SvgElement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "element_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: -911.234,
    y1: 565.796,
    x2: -910.829,
    y2: 565.391,
    gradientTransform: "matrix(64 0 0 -64 58339 36231)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe7651"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#517df8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#element_svg__a)",
    d: "M57 66H9c-4.962 0-9-4.037-9-9V9c0-4.962 4.038-9 9-9h48c4.963 0 9 4.038 9 9v48c0 4.963-4.037 9-9 9zM9 2C5.14 2 2 5.14 2 9v48c0 3.859 3.14 7 7 7h48c3.859 0 7-3.141 7-7V9c0-3.86-3.141-7-7-7H9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3D3",
    d: "M27.706 47.25c-4.938 0-8.956-4.018-8.956-8.956 0-3.49 2.011-6.512 4.931-7.989a9.594 9.594 0 01.796-1.95c-4.189 1.364-7.227 5.302-7.227 9.94 0 5.766 4.69 10.456 10.456 10.456 4.639 0 8.576-3.038 9.94-7.228a9.579 9.579 0 01-1.951.796c-1.476 2.92-4.499 4.931-7.989 4.931z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#989A9C",
    d: "M33 41.956c-4.938 0-8.956-4.018-8.956-8.956 0-3.49 2.011-6.513 4.932-7.99a9.651 9.651 0 01.796-1.95c-4.189 1.364-7.228 5.302-7.228 9.94 0 5.766 4.69 10.456 10.456 10.456 4.639 0 8.576-3.038 9.94-7.228a9.594 9.594 0 01-1.95.796c-1.477 2.921-4.5 4.932-7.99 4.932z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#292D32",
    d: "M38.294 38.162c-5.765 0-10.456-4.69-10.456-10.456s4.69-10.456 10.456-10.456c5.766 0 10.456 4.69 10.456 10.456s-4.69 10.456-10.456 10.456zm0-19.412c-4.938 0-8.956 4.018-8.956 8.956s4.018 8.956 8.956 8.956 8.956-4.018 8.956-8.956-4.018-8.956-8.956-8.956z"
  })));
};
export default SvgElement;